/** load and save data validation type errors from local storage
 */

import { createArrayLocalStorage, LocalStorageKeys } from "core/services/local-storage-service";

const lsTableMappingValidationErrors = createArrayLocalStorage(
    LocalStorageKeys.TableMappingValidationErrors,
    30,
    (existing, incoming) => existing.appId === incoming.appId
);

/** @function save errors
 * save data validation type errors to local storage
 *  @param {string} app - current application
 *  @param {array} errors - list of application errors
 *  @param {object} deploymentInfo - hashmap that contains information about deployment groups {flow, deployment group}
 */
function saveValidationErrors(app, errors, deploymentInfo) {
    return new Promise(function(resolve, reject) {
        if (errors && errors.length > 0) {
            const content = {
                errors: errors,
                deploymentInfo: deploymentInfo,
                appId: app.get("id")
            };
            lsTableMappingValidationErrors.push(content);
        } else {
            lsTableMappingValidationErrors.remove(data => data.appId == app.get("id"));
        }
        resolve();
    });
}

/** @function loadValidationErrors
 * load data validation type from local storage
 *  @param {string} app - current application
 *  @returns {object} information about errors and deployment groups
 */
function loadValidationErrors(app) {
    return new Promise(function(resolve, reject) {
        const allValidationErrors = lsTableMappingValidationErrors.getValue();
        const content = allValidationErrors.find(data => data.appId === app.id) || {};

        if (!content.hasOwnProperty("deploymentInfo")) {
            content.deploymentInfo = {};
        }
        if (!content.hasOwnProperty("errors")) {
            content.errors = [];
        }

        resolve(content);
    });
}

/** @function hasSavedValidationErrors
 * checks if local storage contains errors for application
 *  @param {string} app - current application
 *  @returns {Boolean} true when application has data type validation errors
 */
function hasSavedValidationErrors(app) {
    return new Promise(function(resolve, reject) {
        loadValidationErrors(app).then(content => {
            resolve(content && content.errors && content.errors.length > 0);
        });
    });
}

export { saveValidationErrors, loadValidationErrors, hasSavedValidationErrors };
